import { Controller } from "@hotwired/stimulus"

// A browser counts a clicked select as keyboard focus, because you can type to jump
// between its options. That makes :focus-visible unable to tell a click from a Tab
// on its own, so a pointer press marks the focus that follows as one not to ring.
export default class extends Controller {
  quiet() {
    this.element.dataset.quiet = ""
  }

  restore() {
    delete this.element.dataset.quiet
  }
}
